import { render, staticRenderFns } from "./PostSlider.vue?vue&type=template&id=e5f0d9a2&scoped=true&"
import script from "./PostSlider.vue?vue&type=script&lang=js&"
export * from "./PostSlider.vue?vue&type=script&lang=js&"
import style0 from "./PostSlider.vue?vue&type=style&index=0&id=e5f0d9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0d9a2",
  null
  
)

export default component.exports